(function () {
    'use strict';

    angular.module('spidwebApp').controller('manualSendManagementController', manualSendManagementController);

    manualSendManagementController.$inject = ['$scope', 'parameterService', 'envService', 'axiosService', 'toastService'];

    function manualSendManagementController($scope, parametersService, envService, axiosService, toastService) {
        $scope.locales = [];
        $scope.excludedLocales = [];
        $scope.currentLocale = null;
        $scope.loading = true;

        const CONTEXT = 'translation';
        const NAME = 'excludedLocalSendTranslation';

        $scope.loadData = function () {
            axiosService
                .get(envService.getUrlLanguageDependencies(), {
                    withCredentials: true,
                    headers: {
                        Accept: 'application/json',
                    },
                    cache: false,
                })
                .then(function (localesResponse) {
                    $scope.locales = [...new Set(localesResponse.data.map(item => item.locale))].sort((a, b) => a > b ? 1 : -1).map(name => ({
                        name,
                        excluded: false
                    }));
                    parametersService.getParameter(CONTEXT, NAME).then(function (excludedLocalesResponse) {
                        $scope.excludedLocales = excludedLocalesResponse.split(',');
                        $scope.locales.forEach(locale => {
                            if ($scope.excludedLocales.includes(locale.name)) {
                                locale.excluded = true;
                            }
                        });
                    }).catch(function (error) {
                        console.error(error);
                        toastService.displayTimedToast('Error while getting excluded locales', 'error', 3000);
                    })
                    .finally(function () {
                        $scope.loading = false;
                        $scope.$apply();
                    });
                })
                .catch(function (error) {
                    console.error(error);
                    toastService.displayTimedToast('Error while getting language dependencies', 'error', 3000);
                });
        };

        function init() {
            $scope.loadData();
        }

        $scope.toggleExcluded = function (locale) {
            $scope.loading = true;

            if (!locale.excluded) {
                $scope.excludedLocales = $scope.excludedLocales.filter(item => item !== locale.name);
            } else {
                $scope.excludedLocales.push(locale.name);
            }

            const data = {
                context: CONTEXT,
                name: NAME,
                value: $scope.excludedLocales.join(',')
            };

            parametersService.saveParameter(data)
                .catch(function (error) {
                    console.error(error);
                    toastService.displayTimedToast('Error while saving excluded locales', 'error', 3000);
                })
                .finally(function () {
                    $scope.loading = false;
                    $scope.$apply();
                });
        };

        $scope.localeAsEmojis = function (locale) {
            let country = locale.name.split('_')[1];
            if (country === 'INT') {
                return '🌍';
            }
            return locale.name.split('_')[1].split('').map(letter => letter.charCodeAt(0) % 32 + 0x1F1E5)
                .map(emojiCode => String.fromCodePoint(emojiCode))
                .join('');
        };

        init();


    }
})();
